import React, { FC, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { DependentTaskChanged } from 'api/notifications/meta';
import { useExternalIntegrationUserDetails } from 'hooks/use-external-integration-user-details';
import { InlineLink, Strong } from '../basics';
import { Causer } from './causer';

export const DependentTaskChangedView: FC<{ meta: DependentTaskChanged }> = ({
  meta: { by, addition, removal, externalUser },
}) => {
  const action = addition != null ? 'added' : 'removed';
  const userDetails = useExternalIntegrationUserDetails(externalUser, by);
  const taskId = addition?.taskId;
  const projectId = addition?.project.projectId;
  const open = useCallback(() => {
    if (taskId == null || projectId == null) {
      return;
    }
    const hash = `task${projectId}!${taskId}`;

    if (window.location.hash !== hash) {
      window.location.hash = hash;
    }
  }, [taskId, projectId]);

  return (
    <FormattedMessage
      id="notifications.messages.dependent_task_changed"
      values={{
        causer: <Causer user={userDetails} />,
        title:
          action === 'added' ? (
            <InlineLink title={addition!.taskName} open={open} />
          ) : (
            <Strong>{removal!.taskName}</Strong>
          ),
        action,
      }}
    />
  );
};
